<template>
  <div id="app">
    <v-app class="bodybackground">
      <router-view></router-view>
    </v-app>
  </div>
</template>

<script>
import { typeLogins } from '@/config'

export default {
  methods: {
    resizeHandler() {
			if (window.innerWidth < 992) {
        this.$store.commit('toggleIsMobile', {isMobile: true, menuMini: false})
			} else {
        this.$store.commit('toggleIsMobile', {isMobile: false})
			}
		}
  },
  created() {
    if (typeLogins.type == 'simple') {
      this.$store.dispatch('login/getLoginSimple')
    } else {
      this.$store.dispatch('login/getLogin')
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.resizeHandler)
      this.resizeHandler()
    })
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  }
}
</script>


<style lang="scss">
#app {
  font-family: 'Mukta';
}

.line-height {
  line-height: 1;
}

.index {
  &-3 {
    z-index: 3 !important;
  }
  &-4 {
    z-index: 4 !important;
  }
  &-5 {
    z-index: 5 !important;
  }
}

.my-elevation {
  &-1 {
    box-shadow: 0 1px 1px -1px rgba(0,0,0,.04),0 1px 1px 0 rgba(0,0,0,.04),0 1px 1px 0 rgba(0,0,0,.04)!important;
  }
  &-2 {
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.04),0 2px 1px 0 rgba(0,0,0,.04),0 1px 2px 0 rgba(0,0,0,.04)!important;
  }
  &-3 {
    box-shadow: 0 3px 1px -1px rgba(0,0,0,.04),0 3px 1px 0 rgba(0,0,0,.04),0 1px 3px 0 rgba(0,0,0,.04)!important;
  }
  &-4 {
    box-shadow: 0 4px 1px -1px rgba(0,0,0,.04),0 4px 1px 0 rgba(0,0,0,.04),0 1px 4px 0 rgba(0,0,0,.04)!important;
  }
  &-5 {
    box-shadow: 0 5px 1px -1px rgba(0,0,0,.04),0 5px 1px 0 rgba(0,0,0,.04),0 1px 5px 0 rgba(0,0,0,.04)!important;
  }
}

.w {
  &-100 {
    width: 100%;
  }
  &-50 {
    width: 50%;
  }
}

.login .logo_big{
  width: 200px;
}
.login .theme--light.v-sheet{
  border-radius: 5px;
}

.login .v-text-field .v-label{
  width: 100%;
  max-width: 100%;
  text-align: center;
}
.login .v-input input{
  text-align: center;
}
.login .v-text-field .v-label--active{
  font-size: 10px;
  transform: translateY(-25px) scale(1);
}
.login .v-messages__message{
  text-align: right;
}

.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea{
    color: rgba(0,0,0,1) !important;
}

.v-dialog .theme--light.v-sheet{
  background: #EFEEE8;
}
  .v-dialog .v-card__text{
    display: none;
  }
  .v-dialog .v-card__title, .v-dialog .v-card__text, .v-dialog .v-card__actions{
    padding: 30px;
  }
  
  .v-dialog .red--text.text--darken-1{
    background: #e53935!important;
    color: #ffffff!important;
    caret-color: #ffffff!important;
  }
  
  .v-dialog .green--text.text--darken-1{
    background: #3AB54A!important;
    color: #ffffff!important;
    caret-color: #ffffff!important;
  }
</style>
